<nav class="main-header navbar navbar-expand navbar-white navbar-light">

  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" href="javascript:void(0);" role="button"><i class="fas fa-bars"></i></a>
    </li>
    <li class="nav-item my-1">
      <span class="ds-caption h5">{{componentApplicationName}}</span>
    </li>
  </ul>
  <ul class="navbar-nav ml-auto">
    <li class="nav-item dropdown" *ngIf="notifications.length > 0">
      <a class="nav-link" data-toggle="dropdown" href="#">
        <i class="far fa-bell"></i>
        <span class="badge badge-danger navbar-badge">1</span>
      </a>
      <div class="dropdown-menu dropdown-menu-lg ds-menu-lg dropdown-menu-right">
        <span class="dropdown-header">{{notifications.length}} {{'@direction.ui.navbar.notification.title' | translate}}</span>
        <div *ngFor="let notification of notifications">
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fa-solid fa-server mr-2"></i> {{notification.description}}
            <span class="float-right text-muted text-sm">{{notification.time}}</span>
          </a>
        </div>
      </div>

    </li>
    <li class="nav-item dropdown" *ngIf="dateLastWatchdog">
      <a class="nav-link" data-toggle="dropdown" href="#" (click)="showLastWatchdog()">
        <i class="fa-solid fa-eye"></i>
      </a>
    </li>
  </ul>
</nav>
